export const OutreachTypes = {
  ManualInformational: "manual:informational",
  ManualMarketing: "manual:marketing",
  AutomatedInformational: "automated:informational",
  AutomatedMarketing: "automated:marketing",
}
